import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';

@Component({
  selector: 'app-alertas-confirm',
  templateUrl: './alertasConfirm.component.html',
  styleUrls: ['./alertas.component.css']
})
export class AlertasConfirmComponent implements OnInit {

  tipoMensaje: number;
  titulo: string;

  constructor(private bottomSheetRef: MatBottomSheetRef<AlertasConfirmComponent>,
      @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) { 
        this.tipoMensaje = data.tipoMensaje;
      }

  ngOnInit() {
    this.titulo = this.data;
  }

  btnProceso(tipo: string): void {
    this.bottomSheetRef.dismiss({
      mensaje: tipo
    })
  }
}
